import { useFeatureFlag } from './use-feature-flag';
import { FeatureFlagDeclarations } from '../feature-flag-declarations';

// Note: This experiment has been renamed from GROW-493 to GROW-518, but the feature flag name remains the same.
export const useEnableGrow518Experiment = () => useFeatureFlag(FeatureFlagDeclarations.enableGrow493Experiment);

export const GO_TO_ONBOARDING = 'go-to-onboarding';
export const GO_TO_ORDERS_WITH_AUTOMATION_SHOW_SIDEBAR = 'go-to-orders-with-automation-show-sidebar';
export const GO_TO_ORDERS_WITH_AUTOMATION_HIDE_SIDEBAR = 'go-to-orders-with-automation-hide-sidebar';

export const variantsThatRouteDirectlyToOrdersGridAndShowAutomation = [
  GO_TO_ORDERS_WITH_AUTOMATION_SHOW_SIDEBAR,
  GO_TO_ORDERS_WITH_AUTOMATION_HIDE_SIDEBAR,
];
